<template>
  <div class="login-widget">
    <div class="login-widget-wrapper" v-html="widgetContent">
      <!-- Premium login widget content -->
    </div>
  </div>
</template>

<script>
/**
 * TO TEST OAuth2
 *
 * => Production OAuth2
 * use your own account credential
 *
 * => Staging OAuth2
 * /// Test user accounts ///
 * stgraphics@test.com / Password123
 * stgraphics1@test.com / Password123
 * stgraphics2@test.com / Password123
 *
 */
export default {
  data: function () {
    return {
      widgetContent: ''
    }
  },
  created () {
    this.fetchLoginContent()
  },
  methods: {
    fetchLoginContent () {
      let feedUrl =
        process.env.NODE_ENV === 'production'
          ? 'https://www.straitstimes.com/multimedia/graphics/assets/'
          : 'https://st-graphics-dev-assets.s3-ap-southeast-1.amazonaws.com/'
      feedUrl += 'premium-login-widget/index.html'
      window.fetch(feedUrl).then(res => {
        if (res >= 400) throw new Error(res.statusText)
        return res.text()
      }).then(html => {
        this.widgetContent = html
        this.$nextTick(() => {
          if (document.title) {
            // Update "Login" hyperlink URL
            document.querySelector('.premium-read-more a.login').href = this.$premium.getAuthorizationUrl()
          }
        })
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="scss">
.login-widget {
  padding: 20px 0;

  &.inline {
    .login-widget-wrapper {
      max-width: $d_normal;
      // @include inline_align();
    }
  }

  .login-widget-wrapper {
    max-width: 860px;
    margin: 0 auto;
  }
}
</style>
